import {
  DevicesAPI,
  GetDeviceRequest,
  GetDeviceResponse,
  ListRequest,
  ListResponse,
} from '@weave/schema-gen-ts/dist/schemas/phone/devices/v2/devices.pb';
import { useQuery, UseQueryOptions } from 'react-query';

import { authorizedFetch } from 'helpers/utils';
import { devicesQueryKeys } from './keys';

const CACHE_TIME = 1000 * 60 * 5; // 5 minutes

const useGetDevicesList = <T = ListResponse>(
  request: ListRequest,
  options?: UseQueryOptions<ListResponse, Error, T>
) => {
  return useQuery({
    queryKey: devicesQueryKeys.listDevices({
      locationIds: request.locationIds ?? [],
      include: request.include ?? [],
      tenantId: request.tenantId ?? '',
    }),
    queryFn: () => {
      if (!request.locationIds) {
        return Promise.resolve({});
      }
      return DevicesAPI.List(authorizedFetch(), request);
    },
    retry: false,
    ...options,
    enabled: !!request.locationIds && (options?.enabled ?? true),
    cacheTime: CACHE_TIME,
    staleTime: CACHE_TIME,
  });
};

const useGetDevice = <T = GetDeviceResponse>(
  request: GetDeviceRequest,
  options?: UseQueryOptions<GetDeviceResponse, Error, T>
) => {
  return useQuery({
    queryKey: devicesQueryKeys.getDevice(request.deviceId ?? ''),
    queryFn: () => {
      if (!request.deviceId) {
        return Promise.resolve({});
      }
      return DevicesAPI.GetDevice(authorizedFetch(), request);
    },
    retry: false,
    ...options,
    enabled: !!request.deviceId && (options?.enabled ?? true),
    cacheTime: CACHE_TIME,
    staleTime: CACHE_TIME,
  });
};

export const DevicesQueries = {
  useGetDevicesList,
  useGetDevice,
};
